import { render, staticRenderFns } from "./fangzu.vue?vue&type=template&id=7d5474e2"
import script from "./fangzu.vue?vue&type=script&lang=js"
export * from "./fangzu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports